import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LayoutService } from 'src/app/layout/layout.service';
import { ConfigService } from 'src/app/services/config.service';
import { ThirdPartyService } from '../../third-party.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.component.html',
  styleUrls: ['./account-info.component.scss']
})
export class AccountInfoComponent implements OnInit {
  CompanyInfoForm!: FormGroup;
  subscription = new Subscription;
  sellerDetails: any = {};
  refreshData: boolean = false;
  adminDetails: any = {};
  isShowDeleteAllPopUp: boolean = false;
  branchID: number = 0;
  userID: number = 0;
  isSellerDetailsEdit: boolean = false;

  // for tost msg
  notificationMsg = '';
  showToast: boolean = false;
  isSuccess: boolean;
  branchInfo: any;
  page: number = 1;
  isEditing: boolean = false;
  loading: boolean = true;

  constructor(
    public layoutService: LayoutService,
    public configService: ConfigService,
    public thirdPartyService: ThirdPartyService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.setAllForms();
    this.getUserAndBranchID();
    this.populateToolbarData();
    this.adminDetails = this.configService.getLoginDetails();
  }

  public deleteAllData() {
    this.isShowDeleteAllPopUp = true;
  }

  public closeDeleteAllPopup() {
    this.isShowDeleteAllPopUp = false;
  }

  public ConfirmDeleteAllData() {
    this.loading = true;
    const params = {
      branchID: this.branchID,
      userID: this.userID,
    }
    this.thirdPartyService.deleteAllWorksByBranch(params).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        let response = res?.ResponseData
      }
      this.loading = false;
    }, (error: HttpErrorResponse) => {
      this.loading = false;
    });
    this.closeDeleteAllPopup();
  }

  public updateBranchProfile() {
    this.loading = true;
    if (this.CompanyInfoForm.get('checkBox1')?.value) {
      this.sellerDetails.smsNumber = this.CompanyInfoForm.get('CustomerCare1')?.value;
    } else if (this.CompanyInfoForm.get('checkBox2')?.value) {
      this.sellerDetails.smsNumber = this.CompanyInfoForm.get('CustomerCare2')?.value;
    } else if (this.CompanyInfoForm.get('checkBox3')?.value) {
      this.sellerDetails.smsNumber = this.CompanyInfoForm.get('CustomerCare3')?.value;
    }
    const params = {
      id: this.branchID,
      branchName: this.CompanyInfoForm.get('BranchName')?.value,
      branchCode: this.sellerDetails?.BranchCode,
      branchAddress: this.CompanyInfoForm.get('BranchAddress')?.value,
      smsNumber: this.sellerDetails?.smsNumber,
      place: this.CompanyInfoForm.get('Place')?.value,
      district: this.sellerDetails?.District,
      customerCare: (this.CompanyInfoForm.get('CustomerCare1')?.value ? this.CompanyInfoForm.get('CustomerCare1')?.value : '') + (this.CompanyInfoForm.get('CustomerCare2')?.value ? ',' + this.CompanyInfoForm.get('CustomerCare2')?.value : '') + (this.CompanyInfoForm.get('CustomerCare3')?.value ? ',' + this.CompanyInfoForm.get('CustomerCare3')?.value : ''),
      adminName: this.CompanyInfoForm.get('AdminName')?.value,
      username: this.sellerDetails?.Username,
      updatedBy: this.userID,
    }
    this.thirdPartyService.updateBranchProfile(params).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        this.getBranchProfile();
        this.notify(true, 'Updated company info successfully.');
      } else {
        this.notify(false, 'Failed to update. Please try again.');
      }
      this.loading = false;
    }, (error: HttpErrorResponse) => {
      this.notify(false, 'Failed to update. Please try again.');
      this.loading = false;
    });
    this.isSellerDetailsEdit = false;
    this.CompanyInfoForm.disable();
  }

  private setAllForms() {
    this.CompanyInfoForm = this.fb.group({
      BranchName: ['', [Validators.required]],
      AdminName: [''],
      BranchAddress: [''],
      Place: [''],
      CustomerCare1: [''],
      CustomerCare2: [''],
      CustomerCare3: [''],
      checkBox1: [false],
      checkBox2: [false],
      checkBox3: [false],
    });

    this.CompanyInfoForm.disable();
  }

  private getBranchProfile() {
    this.loading = true;
    let params = {
      branchID: this.branchID,
      branchName: '',
    }
    this.thirdPartyService.getBranchProfile(params).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        let response = res?.ResponseData;
        this.sellerDetails = response;
        const customerCareNumbers = this.sellerDetails?.CustomerCare ? this.sellerDetails?.CustomerCare.split(',') : [];
        const smsNumber = this.sellerDetails?.SMSNumber;
        let box1 = false;
        let box2 = false;
        let box3 = false;
        if (smsNumber) {
          if (customerCareNumbers[0] === smsNumber) {
            box1 = true;
          } else if (customerCareNumbers[1] === smsNumber) {
            box2 = true;
          } else if (customerCareNumbers[2] === smsNumber) {
            box3 = true;
          }
        }
        this.CompanyInfoForm.patchValue({
          BranchName: this.sellerDetails?.BranchName,
          AdminName: this.sellerDetails?.AdminName,
          BranchAddress: this.sellerDetails?.BranchAddress,
          Place: this.sellerDetails?.Place,
          CustomerCare1: customerCareNumbers[0],
          CustomerCare2: customerCareNumbers[1],
          CustomerCare3: customerCareNumbers[2],
          checkBox1: box1,
          checkBox2: box2,
          checkBox3: box3,
        });

      }
      this.loading = false;
    }, (error: HttpErrorResponse) => {
      this.loading = false;
    });
  }

  private getUserAndBranchID() {
    this.thirdPartyService.getStaffIdAndBrandchId().subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        let response = res?.ResponseData;
        this.branchID = response.BranchId;
        this.userID = response.UserId;
        this.getBranchProfile();
      }
    }, (error: HttpErrorResponse) => {
    });
  }

  private populateToolbarData() {
    this.layoutService.setToolbar({
      title: 'Account Info',
    });

    this.layoutService.setNavbarButtons([]);
  }

  private notify(status: boolean, msg: string) {
    this.showToast = true;
    this.isSuccess = status;
    this.notificationMsg = msg;
    setTimeout(() => {
      this.showToast = false;
    }, 3000);
  }

  public toggleCompanyInfoEdit() {
    this.isSellerDetailsEdit = !this.isSellerDetailsEdit;
    if (this.isSellerDetailsEdit) {
      this.CompanyInfoForm.enable();
    } else {
      this.CompanyInfoForm.disable();
    }
  }

  public setSMSNumber(customerCareIndex: number) {
    if (customerCareIndex === 1) {
      const currentValue = this.CompanyInfoForm.get('checkBox1')?.value;
      this.CompanyInfoForm.get('checkBox1')?.setValue(!currentValue);
      this.CompanyInfoForm.get('checkBox2')?.setValue(false);
      this.CompanyInfoForm.get('checkBox3')?.setValue(false);
    } else if (customerCareIndex === 2) {
      const currentValue = this.CompanyInfoForm.get('checkBox2')?.value;
      this.CompanyInfoForm.get('checkBox2')?.setValue(!currentValue);
      this.CompanyInfoForm.get('checkBox1')?.setValue(false);
      this.CompanyInfoForm.get('checkBox3')?.setValue(false);
    } else if (customerCareIndex === 3) {
      const currentValue = this.CompanyInfoForm.get('checkBox3')?.value;
      this.CompanyInfoForm.get('checkBox3')?.setValue(!currentValue);
      this.CompanyInfoForm.get('checkBox1')?.setValue(false);
      this.CompanyInfoForm.get('checkBox2')?.setValue(false);
    }
  }

  public changePge(page: number) {
    if (this.isEditing) {
      const confirmLeave = confirm('You have unsaved changes. Are you sure you want to leave this page?');
      if (!confirmLeave) {
        return;
      }
      this.isEditing = false;
    }
    this.page = page;
  }

}
